(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var CCM = CCM || {};

CCM.Tickets = function ($) {
  var tribe_form = null;
  var ajax_response_element = null;
  var loader = $("<svg class=\"loader loader--circular\" viewBox=\"25 25 50 50\">\n        <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" strokeWidth=\"5\" strokeMiterlimit=\"10\"></circle>\n    </svg>");
  $(document).ready(function () {
    tribe_form = $("#tribe-tickets");
    ajax_response_element = $(".fasts_ajax_resp");
    $("[name='fasts_recurring_event']").change(function (e) {
      getEventTickets($(this).val());
    });
  });

  function getEventTickets(event_id) {
    disableForm();
    hideError();
    $.ajax({
      url: ajax_data.url,
      method: "GET",
      dataType: "json",
      data: {
        action: "get_tickets",
        event_id: event_id
      },
      success: function success(resp) {
        var success = resp.success,
            data = resp.data;

        if (!success) {
          showError(data);
        } else {
          replaceForm(data.html);
          replaceData(data);
        }

        enableForm();
      },
      error: function error(xhr, _error, status) {
        console.error(_error, status);
        showError(_error);
        enableForm();
      }
    });
  }

  function replaceForm(form_html) {
    // Remove attendee registration count above form, it'll be included with the response html
    $(".tribe-link-view-attendee").remove(); // Replace form with response html

    tribe_form.replaceWith($(form_html)); // Re-assign form object

    tribe_form = $("#tribe-tickets");
  }

  function replaceData(data) {
    $(".tribe-event-tags").html(data.tags);
    $(".tribe-events-event-cost").html(data.cost);
    $(".tribe-events-start-date").html(data.start_date);
    $(".tribe-events-start-date").attr("title", data.start_date_full);
    $(".tribe-events-end-date").html(data.end_date);
    $(".tribe-events-end-date").attr("title", data.end_date_full);
    $(".tribe-events-start-datetime").html(data.start_datetime);
    $(".tribe-events-start-date").attr("title", data.start_date_full);
    $(".tribe-events-end-datetime").html(data.end_datetime);
    $(".tribe-events-start-date").attr("title", data.end_date_full);
  }

  function disableForm() {
    tribe_form.addClass("fasts_disabled_form");
    tribe_form.wrap('<div class="fasts_form_loader"></div>');
    $(".fasts_form_loader").append(loader);
  }

  function enableForm() {
    tribe_form.removeClass("fasts_disabled_form");
    $(".fasts-button-target").unwrap(".fasts_form_loader");
    $(".loader--circular").remove();
  }

  function showError(err) {
    ajax_response_element.html(err).addClass("fasts_active");
  }

  function hideError() {
    ajax_response_element.html("").removeClass("fasts_active");
  }
}(jQuery);

},{}]},{},[1]);
